/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _vdkwebNavigation = require("@accedo/vdkweb-navigation");
var _classnames = _interopRequireDefault(require("classnames"));
var _focusButton = _interopRequireDefault(require("./focusButton.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * A button supporting focus management
 * via keys through @accedo/vdkweb-navigation.
 *
 * @param {object} props See propTypes
 * @returns {FocusButton} A FocusButton component
 */
var FocusButton = function FocusButton(_ref) {
  var _classNames;
  var onClick = _ref.onClick,
    nav = _ref.nav,
    children = _ref.children,
    isFocused = _ref.isFocused,
    isSelected = _ref.isSelected,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _focusButton["default"] : _ref$theme;
  var onMouseEnter = nav.onMouseOver,
    onMouseLeave = nav.onMouseOut;
  var className = (0, _classnames["default"])(theme.focusButton, (_classNames = {}, _defineProperty(_classNames, theme.focused, isFocused), _defineProperty(_classNames, theme.selected, !isFocused && isSelected), _classNames));
  return /*#__PURE__*/_react["default"].createElement("button", {
    className: className,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    style: style
  }, children);
};
FocusButton.propTypes = {
  /** Any children to be rendered within the button */
  children: _propTypes["default"].node,
  /** If this button is focused or not */
  isFocused: _propTypes["default"].bool,
  /** If this button is selected or not */
  isSelected: _propTypes["default"].bool,
  /** The @accedo/vdkweb-navigation nav object */
  nav: _propTypes["default"].object,
  /** Click handler */
  onClick: _propTypes["default"].func,
  /** Style object to be applied to the inner button */
  style: _propTypes["default"].object,
  /** Classname API for theming */
  theme: _propTypes["default"].shape({
    focusButton: _propTypes["default"].string,
    focused: _propTypes["default"].string
  })
};
var _default = /*#__PURE__*/_react["default"].memo((0, _vdkwebNavigation.withFocus)(FocusButton));
exports["default"] = _default;